import React, { Component } from 'react';
import { Link } from 'react-router';

import NodeStore from "../stores/NodeStore";
import BandStore from "../stores/BandStore";
import ChannelStore from "../stores/ChannelStore";
import SessionStore from "../stores/SessionStore";


class AlarmComponent extends Component {
  handleDeleteAlarm(e) {
    e.preventDefault();

    this.props.deleteAlarm(this.props.index);
  }

  onChange(field, e) {
    this.props.changeAlarm(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">
      
        <div className="panel panel-heading">
          Alarm #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteAlarm.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="msg">Message</label>
            <input className="form-control" id="msg" type="text" required value={this.props.msg || ''} onChange={this.onChange.bind(this, 'msg')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="formula">Condition&nbsp;(like: x1&gt;100, &nbsp;a2-a1&lt;0. &nbsp;Basic reading is a1..., extended reading is x1...)</label>
            <input className="form-control" id="formula" type="text" required value={this.props.formula || ''} onChange={this.onChange.bind(this, 'formula')} />
          </div>

        </div>

      </div>
    )
  }
}


class TimerComponent extends Component {
  handleDeleteTimer(e) {
    e.preventDefault();

    this.props.deleteTimer(this.props.index);
  }

  onChange(field, e) {
    this.props.changeTimer(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">

        <div className="panel panel-heading">
          Timer #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteTimer.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="timerType">Type</label>
            <select className="form-control" id="timerType" name="timerType" required value={this.props.timerType || 0} onChange={this.onChange.bind(this, "timerType")}>
              <option key="0" value="0">Repeat</option>
              <option key="1" value="1">Once</option>
            </select>        
            <p className="help-block">Repeat timer: The action is repeated every day.</p>
            <p className="help-block">Once timer: The action is only executed once.</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="time">Time</label>
            <input className="form-control" id="time" type="text" required pattern="([^/]+)" value={this.props.time || ''} onChange={this.onChange.bind(this, 'time')} />
            <p className="help-block">Repeat timer format: hh:mm, like: 18:30</p>
            <p className="help-block">Once timer format: YYYY-MM-DD hh:mm:ss, like: 2021-7-20 20:30:00</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="action">Action</label>
            <select className="form-control" id="action" name="action" required value={this.props.action || 0} onChange={this.onChange.bind(this, "action")}>
              <option key="0" value="0">OFF</option>
              <option key="1" value="1">ON</option>
            </select>
            <p className="help-block">ON: turn on the light; OFF: turn off the light.</p>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="brightness">Brightness (0-100)</label>
            <input className="form-control" id="brightness" type="number" required value={this.props.brightness} onChange={this.onChange.bind(this, 'brightness')} />
          </div>

        </div>

      </div>
    )
  }
}


class NodeForm extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "node",
      customServer: SessionStore.customServer,
      application: {},
      node: {
        alarmConfig: {
          flags: 0, 
          alarmItems: [],
        },
        timerConfig: {
          flags: 0,
          timerItems: [],
        },
      },
      FileCreate: false,
      FileMigrate: false,
      DeleteOld: false,
      IgnoreError: false,
      devEUIDisabled: false,
      bands: [],
      channelLists: [],
      disabled: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.updateNodeSettings = this.updateNodeSettings.bind(this);
    this.getRandomDevAddr = this.getRandomDevAddr.bind(this);
    this.getRandomNwkSKey = this.getRandomNwkSKey.bind(this);
    this.getRandomAppSKey = this.getRandomAppSKey.bind(this);

    this.handleAddAlarm = this.handleAddAlarm.bind(this);
    this.changeAlarm = this.changeAlarm.bind(this);
    this.deleteAlarm = this.deleteAlarm.bind(this);
    this.onAlarmChange = this.onAlarmChange.bind(this);

    this.handleAddTimer = this.handleAddTimer.bind(this);
    this.changeTimer = this.changeTimer.bind(this);
    this.deleteTimer = this.deleteTimer.bind(this);
    this.onTimerChange = this.onTimerChange.bind(this);

    BandStore.getAll("", 9999, 0, (totalCount, bands) => {
      this.setState({bands: bands})
    });

    ChannelStore.getAllChannelLists((lists) => {
      this.setState({channelLists: lists});
    });
  }

  componentWillReceiveProps(nextProps) {
    let node = this.updateNodeSettings(nextProps.application, nextProps.node);
    this.setState({
      node: node,
      application: nextProps.application,
      devEUIDisabled: typeof nextProps.node.devEUI !== "undefined" && nextProps.node.devEUI !== "0000000000000000",
      disabled: nextProps.disabled,
    });

  }

  downloadFile(field, e) {
    e.preventDefault();  // 阻止默认行为，避免跳转到文件页面
    
    let downloadUrl = '';
    let fileName = '';
    
    // 根据不同的文件类型设置下载链接和文件名
    if (field === "createNodeFile") {
      downloadUrl = "/report/file_template/createNodeFile.txt";
      fileName = 'createNodeFile.txt';
    }else if (field === "migrateNodeFile") {
      downloadUrl = "/report/file_template/migrateNodeFile.txt";
      fileName = 'migrateNodeFile.txt';
    } else {
      return;
    }
  
    // 创建一个新的 <a> 标签并设置下载属性
    const linkElement = document.createElement('a');
    linkElement.setAttribute("download", fileName);  // 设置下载文件名
    
    // 通过 Blob URL 强制下载文件，避免跳转
    fetch(downloadUrl)
      .then(response => response.blob())  // 获取文件内容
      .then(blob => {
        // 创建一个 Blob URL 并设置为 <a> 标签的 href
        const blobUrl = URL.createObjectURL(blob);
        linkElement.setAttribute('href', blobUrl);
        
        // 添加到 DOM 并模拟点击下载
        document.body.appendChild(linkElement);
        linkElement.click();
        document.body.removeChild(linkElement);
        
        // 清理掉 Blob URL
        URL.revokeObjectURL(blobUrl);
      })
      .catch(err => console.error('Error downloading the file:', err));
  }

  handleSubmit(e) {
    e.preventDefault();
    let node = this.state.node;

    if(node.isABP) {
      node.appKey = "00000000000000000000000000000000";
    } else {
      node.devAddr = "00000000";
      node.nwkSKey = "00000000000000000000000000000000";
      node.appSKey = "00000000000000000000000000000000";
    }

    //node.isClassC = false;
    node.rxWindow = "RX1";
    node.relaxFCnt = true;
    node.rx1DROffset = 0;
    //node.rx2DR = 0;
    node.adrInterval = 0;
    node.installationMargin = 0.0;


    if ( ! node.timerConfig ) {
      node.timerConfig = {
        flags: 0, 
        timerItems: [],
      }
    }
    if ( ! node.timerConfig.timerItems ) {
      node.timerConfig.timerItems = [];
    }

    if ( ! node.alarmConfig ) {
      node.alarmConfig = {
        flags: 0, 
        alarmItems: [],
      }
    }
    if ( ! node.alarmConfig.alarmItems ) {
      node.alarmConfig.alarmItems = [];
    }

    this.props.onSubmit(node);
  }

  changeTab(e) {
    e.preventDefault();
    this.setState({
      activeTab: e.target.getAttribute('aria-controls'),
    });
  }

  updateNodeSettings(application, node) {
    if (node.useApplicationSettings === true) {
      node.rxDelay = application.rxDelay;
      node.rx1DROffset = application.rx1DROffset;
      node.channelListID = application.channelListID;
      node.rxWindow = application.rxWindow;
      node.rx2DR = application.rx2DR;
      node.relaxFCnt = application.relaxFCnt;
      node.adrInterval = application.adrInterval;
      node.installationMargin = application.installationMargin;
      node.isABP = application.isABP;
      node.isClassC = application.isClassC;
      node.bandID = application.bandID;
    }

    if (typeof node.name === 'undefined') {
      node.name = '';
    }
    if (typeof node.description === 'undefined') {
      node.description = '';
    }

    if (typeof node.appKey === 'undefined') {
      node.appKey = '00000000000000000000000000000000';
    }
    if (typeof node.devEUI === 'undefined') {
      node.devEUI = '0000000000000000';
    }
    if (typeof node.devAddr === 'undefined') {
      node.devAddr = '00000000';
    }
    if (typeof node.nwkSKey === 'undefined') {
      node.nwkSKey = '00000000000000000000000000000000';
    }
    if (typeof node.appSKey === 'undefined') {
      node.appSKey = '00000000000000000000000000000000';
    }
    if (typeof node.appEUI === 'undefined') {
      node.appEUI = '0000000000000000';
    }
    if (typeof node.mqttCid === 'undefined') {
      node.mqttCid = '';
    }
    if (typeof node.sn === 'undefined') {
      node.sn = '';
    }
    if (typeof node.address === 'undefined') {
      node.address = '';
    }
    if (typeof node.count === 'undefined') {
      node.count = 1;
    }
    if (typeof node.appKeyDevEUI === 'undefined') {
      node.appKeyDevEUI = false;
    }       

    return node;
  }

  onChange(field, e) {
    let node = this.state.node;
    if (e.target.type === "number") {
      node[field] = parseInt(e.target.value, 10); 
    } else if (e.target.type === "checkbox") {
      node[field] = e.target.checked;
    } else {
      node[field] = e.target.value;
    }
    node = this.updateNodeSettings(this.state.application, node);
    this.setState({node: node});
  };

  onScanChange(field, e) {
    if (e.target.type === "checkbox"){
      if (field === "isFileCreate"){
        let FileCreate = e.target.checked;  
        this.setState({FileCreate: FileCreate});
        if (FileCreate) {
          this.setState({FileMigrate: false});
        }
      }else if (field === "isFileMigrate"){
        let FileMigrate = e.target.checked;  
        this.setState({FileMigrate: FileMigrate});
        if (FileMigrate) {
          this.setState({FileCreate: false});
        }
      }else if(field === "deleteOld"){
        let DeleteOld = e.target.checked;
        this.state.DeleteOld = DeleteOld
        let node = this.state.node;
        node = this.updateNodeSettings(this.state.application, node);
        node['deleteOld']= this.state.DeleteOld;
        this.setState({ node: node });
      }else if(field === "ignoreError"){
        let IgnoreError = e.target.checked;
        this.state.IgnoreError = IgnoreError
        let node = this.state.node;
        node = this.updateNodeSettings(this.state.application, node);
        node['ignoreError']= this.state.IgnoreError;
        this.setState({ node: node });
      }
    }else if (e.target.type === "file") {
      let node = this.state.node;
      node = this.updateNodeSettings(this.state.application, node);
      let fileObj = e.target.files[0];
      let reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      if (field === "deveuiCreateFile") {
        reader.onload = () => {
          let buffer = reader.result;
          let bytes = new Uint8Array(buffer);
          let byteArr = [];
          for (let i = 0; i < bytes.length; i++) {
            byteArr.push(bytes[i]);
          }
          node['createData']= byteArr;
          node['migrateData']= [];
          this.setState({ node: node });
        };
      } else if (field === "deveuiMigrateFile") {
        reader.onload = () => {
          let buffer = reader.result;
          let bytes = new Uint8Array(buffer);
          let byteArr = [];
          for (let i = 0; i < bytes.length; i++) {
            byteArr.push(bytes[i]);
          }
          node['migrateData'] = byteArr;
          node['createData'] = [];
          this.setState({ node: node });
        };
      }
    }
  };


  onAlarmChange(field, e) {
    let node = this.state.node;

    if (field === "userApp") {
      if (e.target.checked) {
        node.alarmConfig.flags &= ~1;
      } else {
        node.alarmConfig.flags |= 1;
      }
    } else {
      if (e.target.type === "number") {
        node.alarmConfig[field] = parseInt(e.target.value, 10); 
      } else if (e.target.type === "checkbox") {
        node.alarmConfig[field] = e.target.checked;
      } else {
        node.alarmConfig[field] = e.target.value;
      }
    }

    //node = this.updateNodeSettings(this.state.application, node);
    this.setState({node: node});
  };


  handleAddAlarm(e) {
    let node = this.state.node;
    
    e.preventDefault();
    if ( ! node.alarmConfig ) {
      node.alarmConfig = {flags: 0, alarmItems: []};
    }
    if ( ! node.alarmConfig.alarmItems ) {
      node.alarmConfig.alarmItems = [];
    }
    node.alarmConfig.alarmItems.push({
      msg: '',
      formula: '',
    });
    
    this.setState({node : node});
  }

  changeAlarm(index, field, e) {
    let node = this.state.node;
    if (e.target.type === "number") {
      node.alarmConfig.alarmItems[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      node.alarmConfig.alarmItems[index][field] = e.target.checked;
    } else {
      node.alarmConfig.alarmItems[index][field] = e.target.value;
    }
    this.setState({node : node});
  }

  deleteAlarm(index) {
    let node = this.state.node;
    node.alarmConfig.alarmItems.splice(index, 1);
    this.setState({node : node});  
  }



  onTimerChange(field, e) {
    let node = this.state.node;

    if (field === "userApp") {
      if (e.target.checked) {
        node.timerConfig.flags &= ~1;
      } else {
        node.timerConfig.flags |= 1;
      }
    } else {
      if (e.target.type === "number") {
        node.timerConfig[field] = parseInt(e.target.value, 10); 
      } else if (e.target.type === "checkbox") {
        node.timerConfig[field] = e.target.checked;
      } else {
        node.timerConfig[field] = e.target.value;
      }
    }

    //node = this.updateNodeSettings(this.state.application, node);
    this.setState({node: node});
  };

  handleAddTimer(e) {
    let node = this.state.node;

    e.preventDefault();
    if (typeof node.timerConfig === 'undefined') {
      node.timerConfig = {
        flags: 0,
        timerItems: [],
      };
    }
    node.timerConfig.timerItems.push({
      timerType: 0,
      time: '',
      action: 1,
      brightness: 100,
    })

    this.setState({node : node});
  }

  changeTimer(index, field, e) {
    let node = this.state.node;
    if (e.target.type === "number") {
      node.timerConfig.timerItems[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      node.timerConfig.timerItems[index][field] = e.target.checked;
    } else {
      node.timerConfig.timerItems[index][field] = e.target.value;
    }
    this.setState({node : node});
  }

  deleteTimer(index) {
    let node = this.state.node;
    node.timerConfig.timerItems.splice(index, 1);
    this.setState({node : node});  
  }



  getRandomDevAddr(e) {
    e.preventDefault();

    if (!this.state.node.isABP || this.props.disabled) {
      return; 
    }

    NodeStore.getRandomDevAddr((responseData) => {
      let node = this.state.node;
      node["devAddr"] = responseData.devAddr;
      this.setState({node: node});
    });
  }

  getRandomNwkSKey(e) {
    let node = this.state.node;

    e.preventDefault();

    if (!node.isABP || this.props.disabled) {
      return;
    }

    let nwkSKey = '';
    const possible = 'abcdef0123456789';
    for(let i = 0; i < 32; i++){
      nwkSKey += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    node["nwkSKey"] = nwkSKey;
    this.setState({node: node});
  }

  getRandomAppSKey(e) {
    let node = this.state.node;

    e.preventDefault();

    if (!node.isABP || this.props.disabled) {
      return;
    }

    let appSKey = '';
    const possible = 'abcdef0123456789';
    for(let i = 0; i < 32; i++){
      appSKey += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    node["appSKey"] = appSKey;
    this.setState({node: node});
  }


  render() {
    let AlarmList = '';
    let TimerList = '';
    let node = this.state.node;
    let hasTimer = false;

    if (!node.alarmConfig || typeof node.alarmConfig.flags === 'undefined') {
      node.alarmConfig = {
        flags: 0,
        alarmItems: []
      }
      this.setState({node : node}); 
    }
    if ( ! node.alarmConfig.alarmItems ) {
      node.alarmConfig.alarmItems = [];
      this.setState({node : node}); 
    }

    if (this.state.customServer === "undefined") {
      this.setState({customServer : SessionStore.customServer}); 
    }

    if (!node.timerConfig || typeof node.timerConfig.flags === 'undefined') {
      node.timerConfig = {
        flags: 0,
        timerItems: []
      }
      this.setState({node : node}); 
    }
    if ( ! node.timerConfig.timerItems ) {
      node.timerConfig.timerItems = [];
      this.setState({node : node}); 
    }


    AlarmList = node.alarmConfig.alarmItems.map((item, i) => 
      <AlarmComponent index={i} msg={item.msg} formula={item.formula} 
        deleteAlarm={this.deleteAlarm} changeAlarm={this.changeAlarm}/>);

    if (typeof this.state.application.appType !== 'undefined' && this.state.application.appType === 4) {
      hasTimer = true;
      if (typeof node.timerConfig !== 'undefined' && typeof node.timerConfig.timerItems !== 'undefined') {
        TimerList = node.timerConfig.timerItems.map((item, i) => 
          <TimerComponent timerType={item.timerType} time={item.time}
            action={item.action} brightness={item.brightness} index={i}
            deleteTimer={this.deleteTimer} 
            changeTimer={this.changeTimer}/>);
      }
    }

    return (
      <div>

        <ul className="nav nav-tabs">
          <li role="presentation" className={(this.state.activeTab === "node" ? 'active' : '')}><a onClick={this.changeTab} href="#node" aria-controls="node">Major parameters</a></li>
          <li role="presentation" className={(this.state.activeTab === "advanced-network-settings" ? 'active' : '')}><a onClick={this.changeTab} href="#advanced-network-settings" aria-controls="advanced-network-settings">More parameters</a></li>
          <li role="presentation" className={(hasTimer ? (this.state.activeTab === "timer" ? 'active' : '') : 'hidden')}><a onClick={this.changeTab} href="#timer" aria-controls="timer">Timer</a></li>
          <li role="presentation" className={(this.state.activeTab === "alarm-settings" ? 'active' : '')}><a onClick={this.changeTab} href="#alarm-settings" aria-controls="alarm-settings">Alarm settings</a></li>
        </ul>

        <hr />

        <form onSubmit={this.handleSubmit}>
          <fieldset disabled={this.state.disabled}>

            <div className={(this.state.activeTab === "node" ? '' : 'hidden')}>
              
              <div className="form-group">
                <label className="control-label">Use application settings</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="useApplicationSettings" id="useApplicationSettings" checked={this.state.node.useApplicationSettings} onChange={this.onChange.bind(this, 'useApplicationSettings')} /> Use application settings
                  </label>
                </div>
                <p className="help-block">
                  When checked, it means that the node will use the (network) settings as set by the application.
                  In case this node requires node-specific (network) settings, uncheck this box.
                </p>
              </div>

              <div className={"form-group " + (this.state.devEUIDisabled ? 'hidden' : '')}>
                <label className="control-label">Use file creation</label>
                <div className={this.state.FileMigrate ? 'hidden' : ''}>
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" name="isFileCreate" id="isFileCreate"  checked={this.state.FileCreate} onChange={this.onScanChange.bind(this, 'isFileCreate')} /> Use file creation
                    </label>
                  </div>
                  <p className="help-block">When checked, a file containing all the necessary information for the node is uploaded to create the node.</p>
                </div>

                <div className={this.state.FileCreate ? 'hidden' : ''}>
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" name="isFileMigrate" id="isFileMigrate"  checked={this.state.FileMigrate} onChange={this.onScanChange.bind(this, 'isFileMigrate')} /> Using file migration
                    </label>
                  </div>
                  <p className="help-block">When checked, a file containing the nodes to be migrated to this application will be uploaded.(All nodes in the file must exist on the server)</p>
                </div>
              </div>

              <div className={"form-group " + (this.state.FileMigrate ? '' : 'hidden')}>  
                <div className="checkbox">
                  <label className="control-label"></label>
                  <label>
                    <input type="file" name="deveuiMigrateFile" id="deveuiMigrateFile"  onChange={this.onScanChange.bind(this, 'deveuiMigrateFile')} />
                  </label>
                </div>
                <p className="help-block">Please select the file with the specified format content.
                  <a onClick={this.downloadFile.bind(this, "migrateNodeFile")}>Refer to file format links</a>
                </p>
              </div>

              <div className={"form-group " + (this.state.FileCreate ? '' : 'hidden')}>
                <div>
                  <label>
                    <input type="checkbox" name="DeleteOld" id="DeleteOld"  checked={this.state.DeleteOld} onChange={this.onScanChange.bind(this, 'deleteOld')} /> If the created node already exists, it is automatically deleted.
                  </label>
                </div>

                <div>
                  <label>
                    <input type="checkbox" name="IgnoreError" id="IgnoreError"  checked={this.state.IgnoreError} onChange={this.onScanChange.bind(this, 'ignoreError')} /> Ignore errors during the creation process.
                  </label>
                </div>
                
                <div className="checkbox">
                <label className="control-label"></label>
                  <label>
                    <input type="file" name="deveuiCreateFile" id="deveuiCreateFile"  onChange={this.onScanChange.bind(this, 'deveuiCreateFile')} />
                  </label>
                </div>
                <p className="help-block">Please select the file with the specified format content.
                  <a onClick={this.downloadFile.bind(this, "createNodeFile")}>Refer to file format links</a>
                </p>
              </div>


              <div className={"form-group " + ((this.state.FileCreate || this.state.FileMigrate) ? 'hidden' : '')}>
                <label className="control-label">ABP (activation by personalisation)</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="isABP" id="isABP" disabled={this.state.node.useApplicationSettings || (this.state.FileCreate || this.state.FileMigrate)} checked={this.state.node.isABP} onChange={this.onChange.bind(this, 'isABP')} /> ABP activation
                  </label>
                </div>
                <p className="help-block">When checked, it means that the node will be manually activated and that over-the-air activation (OTAA) will be disabled.</p>
              </div>


              <div className={"form-group " + ((this.state.FileCreate || this.state.FileMigrate) ? 'hidden' : '')}>
                <label className="control-label" htmlFor="devEUI">Device EUI</label>
                <input className="form-control" id="devEUI" type="text" placeholder="0000000000000000" pattern="[A-Fa-f0-9]{16}" required disabled={this.state.devEUIDisabled} value={this.state.node.devEUI || ''} onChange={this.onChange.bind(this, 'devEUI')} /> 
              </div>

              <div className={"form-group " + (this.state.node.isABP || (this.state.FileCreate || this.state.FileMigrate) ? 'hidden': '')}>
                <label className="control-label" htmlFor="appKey">Application key</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="appKeyDevEUI" id="appKeyDevEUI" checked={this.state.node.appKeyDevEUI} onChange={this.onChange.bind(this, 'appKeyDevEUI')} /> Cover the tail with device EUI
                  </label>
                </div>
                <input className="form-control" id="appKey" type="text" placeholder="00000000000000000000000000000000" pattern="[A-Fa-f0-9]{32}" required={!this.state.node.isABP} value={this.state.node.appKey || ''} onChange={this.onChange.bind(this, 'appKey')} />
              </div>

              <div className={"form-group " + (this.state.node.isABP && !(this.state.FileCreate || this.state.FileMigrate) ? '' : 'hidden')}>
                <label className="control-label" htmlFor="devAddr">Device address</label> (<a href="" onClick={this.getRandomDevAddr}>generate</a>)
                <input className="form-control" id="devAddr" type="text" placeholder="00000000" pattern="[a-fA-F0-9]{8}" required={this.state.node.isABP} disabled={!this.state.node.isABP} value={this.state.node.devAddr || ''} onChange={this.onChange.bind(this, 'devAddr')} />
              </div>
              <div className={"form-group " + (this.state.node.isABP && !(this.state.FileCreate || this.state.FileMigrate) ? '' : 'hidden')}>
                <label className="control-label" htmlFor="nwkSKey">Network session key</label> (<a href="" onClick={this.getRandomNwkSKey}>generate</a>)
                <input className="form-control" id="nwkSKey" type="text" placeholder="00000000000000000000000000000000" pattern="[A-Fa-f0-9]{32}" required={this.state.node.isABP} value={this.state.node.nwkSKey || ''} disabled={!this.props.node.isABP} onChange={this.onChange.bind(this, 'nwkSKey')} />
              </div>
              <div className={"form-group " + (this.state.node.isABP && !(this.state.FileCreate || this.state.FileMigrate) ? '' : 'hidden')}>
                <label className="control-label" htmlFor="appSKey">Application session key</label> (<a href="" onClick={this.getRandomAppSKey}>generate</a>)
                <input className="form-control" id="appSKey" type="text" placeholder="00000000000000000000000000000000" pattern="[A-Fa-f0-9]{32}" required={this.state.node.isABP} value={this.state.node.appSKey || ''} disabled={!this.props.node.isABP} onChange={this.onChange.bind(this, 'appSKey')} />
              </div>

              <div className="form-group">
                <label className="control-label" htmlFor="bandID">ISM Band</label>
                <select className="form-control" id="bandID" name="bandID" disabled={this.state.node.useApplicationSettings} value={this.state.node.bandID  || 1} onChange={this.onChange.bind(this, "bandID")}>
                  {
                    this.state.bands.map((b, i) => {
                      return (<option key={b.id} value={b.id}>{b.name}</option>);
                    })
                  }
                </select>
                <p className="help-block">
                  Different region may use different ISM band. LoRaWAN has defined some ISM bands, and you can define
                  your bands with different channel list.
                </p>
              </div>    

              <div className={"form-group " + ((this.state.FileCreate || this.state.FileMigrate)? 'hidden' : '')}>
                <label className="control-label" htmlFor="count">Number of nodes added or updated</label>
                <input className="form-control" id="count" type="number" min="1" max="100000" required value={this.state.node.count || 1} onChange={this.onChange.bind(this, 'count')} />
                <p className="help-block">Their DevEUI is increasing, and the other parameters are the same.</p>
              </div>

            </div>



            <div className={(this.state.activeTab === "advanced-network-settings" ? '' : 'hidden')}>

              <div className="form-group">
                <label className="control-label" htmlFor="sn">Serial number</label>
                <input className="form-control" id="sn" type="text" placeholder="e.g. '17110814071'" value={this.state.node.sn || ''} onChange={this.onChange.bind(this, 'sn')}  pattern="^[^\\\/?#*<>]+$"/>
                <p className="help-block">
                  The serial number of this node, like: 17110814071.
                </p>
              </div>

              <div className="form-group">
                <label className="control-label" htmlFor="address">Address</label>
                <input className="form-control" id="address" type="text" placeholder="e.g. 'WM23 - For DBO (EC Riser Room)'" value={this.state.node.address || ''} onChange={this.onChange.bind(this, 'address')} />
                <p className="help-block">
                  The address of this node.
                </p>
              </div>

              <div className="form-group hidden">
                <label className="control-label" htmlFor="name">Node description</label>
                <input className="form-control" id="description" type="text" pattern="([^/]+)" placeholder="a short description of your node" value={this.state.node.description || ''} onChange={this.onChange.bind(this, 'description')} />
              </div>

              <div className={(this.state.customServer === "mhs")  ? "hidden" :"form-group"}>
                <label className="control-label" htmlFor="mqttCid">MQTT client id at mydevices.com</label>
                <input className="form-control" id="mqttCid" type="text" placeholder="MQTT client id" value={this.state.node.mqttCid || ''} onChange={this.onChange.bind(this, 'mqttCid')} />
                <p className="help-block">
                  The MQTT client id at mydevices.com for this node. You should create device in you phone app 'Cayenne' first.
                </p>
              </div>

              <div className="form-group" hidden>
                <label className="control-label" htmlFor="appEUI">Application EUI</label>
                <input className="form-control" id="appEUI" type="text" placeholder="0000000000000000" pattern="[A-Fa-f0-9]{16}" value={this.state.node.appEUI || ''} onChange={this.onChange.bind(this, 'appEUI')} />
              </div>

              <div className="form-group">
                <label className="control-label" htmlFor="rxDelay">Receive window delay</label>
                <input className="form-control" id="rxDelay" type="number" min="0" max="15" disabled={this.state.node.useApplicationSettings} required value={this.state.node.rxDelay || 0} onChange={this.onChange.bind(this, 'rxDelay')} />
                <p className="help-block">The delay in seconds (0-15) between the end of the TX uplink and the opening of the first reception slot (0=1 sec, 1=1 sec, 2=2 sec, 3=3 sec, ... 15=15 sec).</p>
              </div>

              <div className="form-group">
                <label className="control-label" htmlFor="channelListID">Channel-list</label>
                <select className="form-control" id="channelListID" name="channelListID" disabled={this.state.node.useApplicationSettings} value={this.state.node.channelListID} onChange={this.onChange.bind(this, "channelListID")}>
                  <option value="0"></option>
                  {
                    this.state.channelLists.map((cl, i) => {
                      return (<option key={cl.id} value={cl.id}>{cl.name}</option>);
                    })
                  }
                </select>
                <p className="help-block">
                  Some LoRaWAN ISM bands implement an optional channel-frequency list that can be sent when using OTAA.
                  Please refer to the LoRaWAN specs for the values that are valid in your region.
                </p>
              </div>
 
              <div className="form-group hidden">
                <label className="control-label">Receive window</label>
                <div className="radio">
                  <label>
                    <input type="radio" name="rxWindow" id="rxWindow1" value="RX1" disabled={this.state.node.useApplicationSettings} checked={this.state.node.rxWindow === "RX1"} onChange={this.onChange.bind(this, 'rxWindow')} /> RX1
                  </label>
                </div>

                <div className="radio">
                  <label>
                    <input type="radio" name="rxWindow" id="rxWindow2" value="RX2" disabled={this.state.node.useApplicationSettings} checked={this.state.node.rxWindow === "RX2"} onChange={this.onChange.bind(this, 'rxWindow')} /> RX2 (one second after RX1)
                  </label>
                </div>
              </div>

              <div className="form-group hidden">
                <label className="control-label">Relax frame-counter</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="relaxFCnt" id="relaxFCnt" disabled={this.state.node.useApplicationSettings} checked={this.state.node.relaxFCnt} onChange={this.onChange.bind(this, 'relaxFCnt')} /> Enable relax frame-counter
                  </label>
                </div>
                <p className="help-block">Note that relax frame-counter mode will compromise security as it enables people to perform replay-attacks.</p>
              </div>

              <div className="form-group hidden">
                <label className="control-label" htmlFor="rx1DROffset">RX1 data-rate offset</label>
                <input className="form-control" id="rx1DROffset" type="number" disabled={this.state.node.useApplicationSettings} value={this.state.node.rx1DROffset || 0} onChange={this.onChange.bind(this, 'rx1DROffset')} />
                <p className="help-block">
                  Sets the offset between the uplink data rate and the downlink data-rate used to communicate with the end-device on the first reception slot (RX1).
                  Please refer to the LoRaWAN specs for the values that are valid in your region.
                </p>
              </div>

              <div className="form-group">
                <label className="control-label" htmlFor="rx2DR">RX2 data-rate</label>
                <input className="form-control" id="rx2DR" type="number" disabled={this.state.node.useApplicationSettings} value={this.state.node.rx2DR || 0} onChange={this.onChange.bind(this, 'rx2DR')} />
                <p className="help-block">
                  The data-rate to use when RX2 is used as receive window.
                  Please refer to the LoRaWAN specs for the values that are valid in your region.
                </p>
              </div>

              <div className="form-group hidden">
                <label className="control-label" htmlFor="adrInterval">ADR interval</label>
                <input className="form-control" id="adrInterval" type="number" disabled={this.state.node.useApplicationSettings} value={this.state.node.adrInterval || 0} onChange={this.onChange.bind(this, 'adrInterval')} />
                <p className="help-block">
                  The interval (of frames) after which the network-server will ask the node to change data-rate and / or TX power
                  if it can change to a better data-rate or lower TX power. Setting this to 0 will disable ADR. 
                </p>
              </div>

              <div className="form-group hidden">
                <label className="control-label" htmlFor="installationMargin">Installation margin (dB)</label>
                <input className="form-control" id="installationMargin" type="number" disabled={this.state.node.useApplicationSettings} value={this.state.node.installationMargin || 0} onChange={this.onChange.bind(this, 'installationMargin')} />
                <p className="help-block">
                  The installation margin which is taken into account when calculating the ideal data-rate and TX power.
                  A higher margin will lower the data-rate, a lower margin will increase the data-rate and possibly packet loss.
                  5dB is the default recommended value.
                </p>
              </div>

              <div className="form-group">
                <label className="control-label">Class-C node</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="isClassC" id="isClassC" disabled={this.state.node.useApplicationSettings} checked={this.state.node.isClassC} onChange={this.onChange.bind(this, 'isClassC')} /> Class-C node
                  </label>
                </div>
                <p className="help-block">
                  When checked, it means that the node operates in Class-C mode (always listening) and that data will be sent directly to the node. <br/>
                  In any other case, the data will be sent as soon as a receive window occurs.
                </p>
              </div>

            </div>


            <div className={(this.state.activeTab === "timer" ? '' : 'hidden')}>
              <div className="form-group">
                <label className="control-label">Use application timer settings</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="userApp" id="userApp" checked={(this.state.node.timerConfig.flags&1)===0} onChange={this.onTimerChange.bind(this, 'userApp')} /> Use application timer settings
                  </label>
                </div>
                <p className="help-block">
                  When checked, it means that this node's timer settings is same as application's timer settings. <br/>
                </p>
              </div>

              {TimerList}
              <br />
            </div>


            <div className={(this.state.activeTab === "alarm-settings" ? '' : 'hidden')}>
              <div className="form-group">
                <label className="control-label">Use application alarm settings</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="userApp" id="userApp" checked={(this.state.node.alarmConfig.flags&1)===0} onChange={this.onAlarmChange.bind(this, 'userApp')} /> Use application alarm settings
                  </label>
                </div>
                <p className="help-block">
                  When checked, it means that this node's alarm settings is same as application's alarm settings. <br/>
                </p>
              </div>

              {AlarmList}
              <br />
            </div>


            <hr />

            <div className="btn-group pull-right" role="group" aria-label="...">
              &nbsp;<Link className={(this.state.activeTab === "timer" ? '' : 'hidden')}><button type="button" onClick={this.handleAddTimer.bind(this)} className="btn btn-default">Add timer</button></Link>
              &nbsp;<Link className={(this.state.activeTab === "alarm-settings" ? '' : 'hidden')}><button type="button" onClick={this.handleAddAlarm.bind(this)} className="btn btn-default">Add alarm</button></Link>
              &nbsp;<button type="submit" className={"btn btn-primary pull-right " + (this.state.disabled ? 'hidden' : '')}>Submit</button>
            </div>

          </fieldset>
        </form>
      </div>
    );
  }
}

export default NodeForm;



// WEBPACK FOOTER //
// ./src/components/NodeForm.js